<template>
  <div class="mb-6">
    <textarea
      ref="inputRef"
      v-model="text"
      placeholder="Dump your ideas here... one thought or many. Double newlines separate multiple ideas."
      class="w-full rounded border border-gray-300 bg-white px-4 py-3 text-sm text-gray-800 placeholder-gray-400
             focus:border-teal-500 focus:ring-1 focus:ring-teal-500 outline-none resize-y"
      rows="4"
      @keydown.meta.enter.prevent="save"
      @keydown.ctrl.enter.prevent="save"
    ></textarea>

    <div class="flex items-center gap-2 mt-2">
      <button
        @click="save"
        :disabled="!text.trim() || saving"
        class="text-sm font-medium px-4 py-2 rounded bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-50 disabled:cursor-not-allowed"
      >Save</button>

      <button
        @click="splitSave"
        :disabled="!text.trim() || saving"
        class="text-sm font-medium px-4 py-2 rounded border border-gray-300 text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
      >Split &amp; Save</button>

      <span class="text-xs text-gray-400 ml-auto">Cmd+Enter to save</span>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick } from 'vue'

const props = defineProps({
  saving: Boolean,
})

const emit = defineEmits(['save', 'split-save'])

const text = ref('')
const inputRef = ref(null)

function save() {
  const body = text.value.trim()
  if (!body) return
  emit('save', body)
  text.value = ''
  nextTick(() => inputRef.value?.focus())
}

function splitSave() {
  const body = text.value.trim()
  if (!body) return
  const bodies = body.split(/\n\s*\n/).map(s => s.trim()).filter(Boolean)
  if (bodies.length <= 1) {
    emit('save', body)
  } else {
    emit('split-save', bodies)
  }
  text.value = ''
  nextTick(() => inputRef.value?.focus())
}
</script>
